export default async function createModals(debug = false) {
  let openEls = document.querySelectorAll('.js-modal-open');
  if (! openEls.length) return;

  const { default: Modal } = await import('../classes/Modal');

  openEls.forEach(openEl => {
    new Modal(openEl, debug);
  });
}

window.recreateModals = () => {
  // console.log('recreateModals');
  createModals();
  // console.log(modalObjects);
};
